export default __webpack_public_path__ + "static/DailyDiscomfort-44fa0afe3e96db16a7040997bbe55a28.png";